import * as React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-ui";

import { toHtmlElementOrNull } from "../../Commons/DOM/DomHelpers";

import type { LinkProps } from "./Link";

export const linkTestPageObject = (props: LinkProps, handleClick: () => void, linkRef: React.RefObject<Link>) => ({
    getType: () => "Link",

    click: (): void => {
        handleClick();
    },

    isDisabled: (): boolean => Boolean(props.disabled),

    isFocused: (): boolean => {
        if (linkRef.current == undefined) {
            return false;
        }
        const linkElement = toHtmlElementOrNull(ReactDOM.findDOMNode(linkRef.current));
        if (linkElement == undefined) {
            return false;
        }
        const link = linkElement.querySelector("link");

        return document.activeElement === link;
    },

    isInView: (): boolean => {
        if (linkRef.current == undefined) {
            return false;
        }
        const linkElement = toHtmlElementOrNull(ReactDOM.findDOMNode(linkRef.current));
        if (linkElement == undefined) {
            return false;
        }
        const rect = linkElement.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= document.documentElement.clientHeight &&
            rect.right <= document.documentElement.clientWidth
        );
    },

    getLinkText: (): string | null => {
        const link = toHtmlElementOrNull(ReactDOM.findDOMNode(linkRef.current));
        return link?.textContent?.trim() ?? null;
    },
});
